{
  "version": 1,
  "asset_id": "6ceede62-c296-4bf2-8504-4b1ba4b959e5",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/6ceede62-c296-4bf2-8504-4b1ba4b959e5/sleeve-normal-revision-480.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/6ceede62-c296-4bf2-8504-4b1ba4b959e5/sleeve-normal-revision-480.jpg",
  "original_filename": "sleeve-normal-revision-480.jpg",
  "size": 35280,
  "content_type": "image/jpeg",
  "created_at": "2026-10-05T01:21:28Z"
}
